export default {
  "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["first page content"])}
}